import { RadioButtonGroup } from 'commons/components';
import { useTranslationCustomers } from 'domains/Customers/hooks';

interface WholesaleFilterProps {
  value: string;
  onChange: ({ value }) => void;
}

export default function WholesaleFilter({
  value,
  onChange,
}: Readonly<WholesaleFilterProps>) {
  const t = useTranslationCustomers();
  const tPath = 'customerListPage.filterModal.b2bFilter';

  const options = [
    {
      label: t(`${tPath}.all`),
      value: '',
    },
    {
      label: t(`${tPath}.retail`),
      value: 'false',
    },
    {
      label: t(`${tPath}.wholesale`),
      value: 'true',
    },
  ];

  return (
    <RadioButtonGroup
      label={t(`${tPath}.label`)}
      name="wholesale-filter"
      options={options}
      onChange={onChange}
      value={value}
    />
  );
}
